import React, { FC } from "react";
import { WrapperSection } from "@ldp-web/component-library/ui/atoms/section";
import { Banner } from "@ldp-web/component-library/ui/molecules/banner";
import { useRedirectLink } from "../../utils";
import { useSDMRouterContext } from "@ldp/sdm-contexts";

/** hero image */
export type Image = {
  /** image url */
  url: string;
  /** image mimetype */
  mimeType: string;
  /** image type */
  type: string;
};

/** Hero image props types */
export type HeroImage = {
  /** image title */
  title: string;
  /** hero image alt text */
  altText: string;
  /** hero image for desktop */
  desktopImage: Image;
  /** hero image for mobile */
  mobileImage: Image;
  /** hero image for tablet */
  tabletImage: Image;
};

/** hero banner renderer props type */
export type HeroBannerComponentProps = {
  /** hero banner title */
  bannerTitle: string;
  /** hero banner subtitle */
  bannerSubtitle: string;
  /** hero banner image */
  heroImage: HeroImage;
  /** Body text color in the Hero Banner component */
  bannerSubtitleColor?: string;
  /** background color of the Hero Banner component */
  bannerBgColor?: string;
  /** Header text color in the Hero Banner component */
  bannerTitleColor?: string;
  /** id of component */
  id?: string;
};

/** Hero Banner Component */
export const HeroBannerComponent: FC<HeroBannerComponentProps> = ({
  bannerTitle,
  heroImage,
  bannerSubtitle,
  bannerSubtitleColor,
  bannerTitleColor,
  bannerBgColor,
  id,
}) => {
  const router = useSDMRouterContext();
  const redirectToPage = useRedirectLink(router);

  return (
    <WrapperSection shouldUseSpacingExtraLarge id={id}>
      <Banner
        desktopImage={heroImage?.desktopImage}
        mobileImage={heroImage?.mobileImage}
        tabletImage={heroImage?.tabletImage}
        bodyText={bannerSubtitle}
        title={bannerTitle}
        variant="full"
        bodyTextColor={bannerSubtitleColor}
        titleColor={bannerTitleColor}
        buttonClickHandler={redirectToPage}
        backgroundColor={bannerBgColor}
        innerContentBackgroundColor={bannerBgColor}
      />
    </WrapperSection>
  );
};

export default HeroBannerComponent;
